import { render, staticRenderFns } from "./ContactSupportLink.vue?vue&type=template&id=49da9b29&"
import script from "./ContactSupportLink.vue?vue&type=script&lang=js&"
export * from "./ContactSupportLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports